import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "../../../../components/commonComponent/Form";
import { FIELDS, MODE } from "../../../../constants/SiteConstants";
import Loader from "../../../../components/commonComponent/Loader";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: FIELDS.NAME, name: "name", placeholder: "Enter Name" },
  { label: FIELDS.SLUG, name: "slug", placeholder: "Enter Slug" },
  {
    label: "Banner",
    name: "images",
    placeholder: "Choose Image",
    type: "file",
    // required: true
  },
  
];

const EditProductCategory = () => {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const loadDoctorData = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/productcategory/getproductcategoryById/${id}`
          );
          setInitialData(response.data.data);
        } catch (error) {}
      };
      loadDoctorData();
    }
  }, [id]);

const handleSubmit = async (formData) => {
  try {
    // ✅ Check if a new image is selected (File object)
    if (formData.images instanceof File) {
      const imageFormData = new FormData();
      imageFormData.append("image", formData.images);

      const response = await fetch(`${API_URL}/image/upload`, {
        method: "POST",
        body: imageFormData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Image upload failed");
      }

      // ✅ Replace file with uploaded image URL
      formData.images = data.imageUrl;
    }

    await axios.put(`${API_URL}/productcategory/updateproductcategory/${id}`, formData);

    toast.success("Data updated successfully", {
      autoClose: 1000,
    });
    navigate("/product-category");
  } catch (error) {
    console.error("Error updating category:", error);
    toast.error("Error updating data", {
      autoClose: 1000,
    });
  }
};


  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
      <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update Product Category</h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/product-category")}
        >
          &times;
        </button>
      </div>
      {initialData ? (
        <Form
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          initialData={initialData}
        />
      ) : (
        <Loader/>
      )}
    </div>
  );
};

export default EditProductCategory;
